(function() {

    "use strict";

    angular.module("directives", []);
})();